export const COMPANY_ID = {
    wave: 'wave',
	track: 'track',
	techemy: 'techemy',
	propine: 'propine',
	strix: 'strix',
}

export const TRANSITION_DURATION = 1000;
